var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.8293 23.6C9.35272 23.5974 8.8964 23.4069 8.55941 23.0699C8.22241 22.7329 8.03192 22.2766 8.0293 21.8V12.38C8.03192 11.9034 8.22241 11.4471 8.55941 11.1101C8.8964 10.7731 9.35272 10.5826 9.8293 10.58H11.6093V8.8C11.6119 8.32342 11.8024 7.86711 12.1394 7.53011C12.4764 7.19311 12.9327 7.00263 13.4093 7H21.9393C22.4159 7.00263 22.8722 7.19311 23.2092 7.53011C23.5462 7.86711 23.7367 8.32342 23.7393 8.8V18.22C23.7367 18.6966 23.5462 19.1529 23.2092 19.4899C22.8722 19.8269 22.4159 20.0174 21.9393 20.02H20.1293V21.8C20.1267 22.2766 19.9362 22.7329 19.5992 23.0699C19.2622 23.4069 18.8059 23.5974 18.3293 23.6H9.8293ZM9.6293 22H18.5293V12.18H9.5993L9.6293 22ZM13.2093 10.58H18.3293C18.8059 10.5826 19.2622 10.7731 19.5992 11.1101C19.9362 11.4471 20.1267 11.9034 20.1293 12.38V18.38H22.1293V8.6H13.1793L13.2093 10.58Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.4d34e68bb184b8e410aa5002a6ef98c4.svg";
export { ForwardRef as ReactComponent };